import request from '@/utils/request'

export function epms9110List(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9110/epms9110List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9111List(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9110/epms9111List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms9110Devide(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9110/epms9110Devide`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}